import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { BookingComponent } from './booking.component';
import { SharedModule } from '../shared/shared.module';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatRippleModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CalendarModule } from '../calendar/calendar.module';

@NgModule({
    declarations: [BookingComponent],
    imports: [
        SharedModule,
        MatButtonModule,
        MatInputModule,
        TextFieldModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatDividerModule,
        MatRippleModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        CalendarModule
    ]
})
export class BookingModule { }
